import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Language } from '../App';
interface HowItWorksProps {
  language: Language;
}
const content = {
  en: {
    title: 'How It Works',
    steps: [{
      number: '01',
      title: 'Submit Request',
      description: 'Fill out our confidential consultation form with your information'
    }, {
      number: '02',
      title: 'Coordinator Contacts You',
      description: 'Our team reaches out within 24 hours to discuss your needs'
    }, {
      number: '03',
      title: 'Appointment Confirmed',
      description: 'We schedule your private consultation at a convenient time'
    }, {
      number: '04',
      title: 'Private Consultation',
      description: 'Meet with our board-certified physician in complete privacy'
    }]
  },
  es: {
    title: 'Cómo Funciona',
    steps: [{
      number: '01',
      title: 'Enviar Solicitud',
      description: 'Complete nuestro formulario de consulta confidencial con su información'
    }, {
      number: '02',
      title: 'El Coordinador Se Comunica',
      description: 'Nuestro equipo se comunica en 24 horas para discutir sus necesidades'
    }, {
      number: '03',
      title: 'Cita Confirmada',
      description: 'Programamos su consulta privada en un momento conveniente'
    }, {
      number: '04',
      title: 'Consulta Privada',
      description: 'Reúnase con nuestro médico certificado en completa privacidad'
    }]
  }
};
export function HowItWorks({
  language
}: HowItWorksProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const t = content[language];
  return <section ref={ref} className="py-24 px-4 sm:px-6 lg:px-8 bg-espresso" data-id="element-115" data-mp="1kxhezigeo4m9">
      <div className="max-w-7xl mx-auto" data-id="element-116" data-mp="1kzkd6prpp422">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-4xl sm:text-5xl font-bold text-pearl text-center mb-16" data-id="element-117" data-mp="3l08ocblav1hc">
          {t.title}
        </motion.h2>

        <div className="relative" data-id="element-118" data-mp="7r4bipjs8rmm">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-pearl/20 -translate-y-1/2" data-id="element-119" data-mp="cr8k7teg8i2a" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4 relative" data-id="element-120" data-mp="hjtban5z0h24">
            {t.steps.map((step, index) => <motion.div key={step.number} initial={{
            opacity: 0,
            y: 50
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} className="relative" data-id="element-121" data-mp="lmg6my1uok42" data-mpi={index}>
                <div className="flex flex-col items-center text-center space-y-4" data-id="element-122" data-mp="rn72lf9lo7t6">
                  <div className="relative" data-id="element-123" data-mp="1ocofae702u4d">
                    <div className="w-20 h-20 rounded-full bg-pearl flex items-center justify-center text-espresso text-2xl font-bold shadow-lg ring-4 ring-espresso" data-id="element-124" data-mp="1ocg0ggrbheqj">
                      {step.number}
                    </div>
                    {index < t.steps.length - 1 && <div className="hidden lg:block absolute top-1/2 left-full w-full h-0.5 bg-pearl/40 -translate-y-1/2" data-id="element-125" data-mp="1akhzwubo8r5z" />}
                  </div>
                  <h3 className="text-xl font-bold text-pearl" data-id="element-126" data-mp="22cz5df0hk4oh">{step.title}</h3>
                  <p className="text-pearl/70 text-sm max-w-xs" data-id="element-127" data-mp="22aw4u11pit5i">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}